export default "__VITE_ASSET__x8MMXChZ__"